import { render, staticRenderFns } from "./BindDevice.vue?vue&type=template&id=158bd1f6&scoped=true"
import script from "./BindDevice.vue?vue&type=script&lang=js"
export * from "./BindDevice.vue?vue&type=script&lang=js"
import style0 from "./BindDevice.vue?vue&type=style&index=0&id=158bd1f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158bd1f6",
  null
  
)

export default component.exports